var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick1New(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.5C20.6274 2.5 26 7.87258 26 14.5C26 21.1274 20.6274 26.5 14 26.5C7.37258 26.5 2 21.1274 2 14.5C2 7.87258 7.37258 2.5 14 2.5ZM19.915 10.793C19.5246 10.4025 18.8915 10.4026 18.501 10.793L11.708 17.5859L8.91504 14.793C8.52458 14.4025 7.89152 14.4026 7.50098 14.793C7.11045 15.1835 7.11045 15.8165 7.50098 16.207L11.001 19.707C11.1885 19.8945 11.4429 20 11.708 20C11.9731 19.9999 12.2276 19.8945 12.415 19.707L19.915 12.207C20.3053 11.8166 20.3053 11.1834 19.915 10.793Z",
    fill: "#00C7D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick1New);
export default __webpack_public_path__ + "static/media/Tick_1New.d779467bfe14352f62255abf14797a1b.svg";
export { ForwardRef as ReactComponent };